import React from "react";
import { RPE_GRID, RPE_REPS, RPE_SCALE, roundTo, fmt, toNum } from "../lib/calc";
import { Gauge } from "lucide-react";

export const RpeGrid = ({ oneRM, unit, rounding }) => {
  const rm = toNum(oneRM);
  const [showLoads, setShowLoads] = React.useState(true);

  return (
    <div className="tactical-card p-5 sm:p-6 animate-fade" data-testid="rpe-grid">
      <div className="flex items-start justify-between gap-3 flex-wrap mb-4">
        <div>
          <div className="eyebrow flex items-center gap-2">
            <Gauge size={12} /> Autorégulation · RTS
          </div>
          <h2 className="font-display text-2xl sm:text-3xl font-extrabold uppercase text-white leading-none mt-1">
            Grille Reps @ RPE
          </h2>
          <p className="text-xs text-slate-400 mt-1.5 max-w-xl leading-relaxed">
            Barème <span className="text-slate-200">RPE / RIR de Mike Tuchscherer
            (Reactive Training Systems)</span> — RPE 10 = 0 rep en réserve.
            Croise le nombre de reps avec le RPE visé pour obtenir le % du 1RM.
          </p>
        </div>
        <button
          data-testid="rpe-grid-toggle"
          onClick={() => setShowLoads((s) => !s)}
          className="btn-ghost px-3 py-2 rounded-sm text-[11px] font-mono uppercase tracking-widest"
        >
          {showLoads ? `Afficher %` : `Afficher charges (${unit})`}
        </button>
      </div>

      <div className="overflow-x-auto -mx-2">
        <table className="w-full min-w-[760px] border-collapse">
          <thead>
            <tr className="border-b border-white/10">
              <th className="eyebrow py-2 px-2 text-left">RPE / RIR</th>
              {RPE_REPS.map((r) => (
                <th key={r} className="eyebrow py-2 px-1 text-center">
                  {r}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="stripe">
            {RPE_GRID.map((row) => (
              <tr
                key={row.rpe}
                data-testid={`rpe-row-${row.rpe}`}
                className="border-b border-white/5 hover:bg-white/[0.03] transition"
              >
                <td className="py-2 px-2 whitespace-nowrap">
                  <span className="font-mono text-base font-black text-[#cd383d] tabular">
                    {row.rpe}
                  </span>
                  <span className="text-slate-500 text-[10px] font-mono ml-2 uppercase tracking-widest">
                    {row.rir} RIR
                  </span>
                </td>
                {row.pcts.map((p, i) => (
                  <td key={i} className="py-2 px-1 text-center">
                    <span className="font-mono text-sm text-white tabular">
                      {showLoads && rm
                        ? fmt(roundTo((rm * p) / 100, rounding), rounding ? 0 : 1)
                        : `${fmt(p, 1)}%`}
                    </span>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-2">
        {RPE_SCALE.map((s) => (
          <div
            key={s.rpe}
            className="flex items-start gap-3 rounded-sm bg-black/25 border border-white/10 px-3 py-2"
          >
            <span className="font-mono text-sm font-black text-[#cd383d] tabular w-8 shrink-0">
              {s.rpe}
            </span>
            <div>
              <div className="text-[10px] font-mono uppercase tracking-widest text-slate-500">
                {s.rir} rep(s) en réserve
              </div>
              <div className="text-xs text-slate-300">{s.desc}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
